import { array, struct } from 'io-ts/Decoder';

import { Id as FileId } from '../../../../file/Id';

export const Request = struct({
	fileIds: array(FileId),
});
